import React, { useState, useEffect } from "react";
import CommonPageHeader from "../../components/CommonPageHeader/CommonPageHeader";
import HomeFooter from "../Home/Home/HomeFooter/HomeFooter";
import HomeFact from "../Home/Home/HomeFact/HomeFact";
import HomeHeader from "../Home/Home/HomeHeader/HomeHeader";
import HomeOurTeam from "../Home/Home/HomeOurTeam/HomeOurTeam";
import AboutAnalysis from "./AboutAnalysis/AboutAnalysis";
import AboutAppoinment from "./AboutAppoinment/AboutAppoinment";
import AboutArea from "./AboutArea/AboutArea";
import HomeFiveHowWorks from "../HomeFive/HomeFiveHowWorks/HomeFiveHowWorks";
import HomeThreeFaq from "../HomeThree/HomeThreeFaq/HomeThreeFaq";
import { buscarServico } from "../../hooks/getService";

const InvestigacaoInfertilidade = () => {
  const [servicoData, setServicoData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const idArea = 1;
  const idServico = 6;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await buscarServico(idServico);
        if (data) {
          setServicoData(data);
        } else {
          console.error("Erro ao buscar dados do serviço.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [idServico]);

  // Formatter para moeda BRL
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const title = servicoData?.Nome || "Investigação de Infertilidade";
  const descricao =
    "Nossa missão é fornecer um ambiente acolhedor e de confiança, onde o casal se sinta apoiado em cada passo do processo de investigação da infertilidade.";

  // Calcula o preço baseado nos dados reais
  const precoAVista = servicoData?.Preco ? Number(servicoData.Preco) : 0;
  const parcela6x = servicoData?.Parcelas?.find(
    (p) => p.QuantidadeParcelas === 6
  )?.ValorParcela;
  const valorParcela6x = parcela6x ? Number(parcela6x) / 6 : 0;
  const price = servicoData
    ? `${formatarMoeda(precoAVista)} ou até 6x de ${formatarMoeda(
        valorParcela6x
      )}`
    : "Carregando preço...";

  const fatos = {
    titulo_fatos: "Juntas nesse desafio",
    descricao_fatos:
      "Enfrentar dificuldades para conceber pode ser um desafio emocional e físico para qualquer casal. Nosso serviço de pesquisa de infertilidade conjugal está aqui para oferecer o suporte e a expertise necessários para transformar esse sonho em realidade",
    subtitulos: [
      {
        titulo: "Cada casal é único",
        subtitulo:
          "Com uma abordagem personalizada e cuidadosa, buscamos compreender as necessidades específicas de cada casal, realizando uma análise detalhada e individualizada para identificar possíveis causas da infertilidade.",
      },
      {
        titulo: "Conte com nossa ajuda",
        subtitulo:
          "Porque juntas, podemos transformar desafios em conquistas. Entre em contato conosco hoje mesmo para dar o primeiro passo em direção à realização do seu desejo de ter um filho.",
      },
    ],
  };

  const passos = [
    {
      titulo: "Agendamento do serviço",
      descricao: "Escolha o melhor horário para você",
    },
    {
      titulo: "Envio de exames prévios para nosso link de whatsapp se houverem",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Recebimento do Link de Atendimento, via Whatsapp",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Consulta Online (~45 min)",
      descricao: "Aguarde o retorno",
    },
    {
      titulo:
        "Envio de exames prévios via link recebido pelo WhatsApp, se houverem",
      descricao: "Realize os exames",
    },
    {
      titulo: "Retorno em até 30 dias para ver seus exames.",
      descricao: "Aguarde o retorno",
    },
    {
      titulo: "Envio de relatório Médico",
      descricao: "Receba o relatório médico",
    },
  ];

  const imgUrl = "img/services/6.Infertilidade.png";

  if (isLoading) {
    return (
      <>
        <HomeHeader />
        <div style={{ textAlign: "center", padding: "50px" }}>
          <h2>Carregando...</h2>
        </div>
        <HomeFooter />
      </>
    );
  }

  return (
    <>
      <HomeHeader />
      <AboutArea
        title={title}
        descricao={descricao}
        price={price}
        idArea={idArea}
        idServico={idServico}
        imgUrl={imgUrl}
      />
      <HomeFact fatos={fatos} />
      <AboutAppoinment passos={passos} />
      <HomeThreeFaq />
      <HomeFooter />
    </>
  );
};

export default InvestigacaoInfertilidade;
